import request from '../utils/request';
import { baseURL } from '@/utils/baseConfig';
import { SSE } from "sse.js";
import { getToken } from '@/utils/auth'

/**
 * 自动化思维列表
 */
export const autoThoughtRecognitionList = () => {
  return request.get(`/app-api/therapy/report/autoThoughtRecognition`);
};

/**
 * 通用报告
 */
export const getCommonDetail = (id) => {
  return request.get(`/app-api/therapy/report/getCommonDetail?id=${id}`);
};

/**
 * 编辑报告
 */
export const submitForTools = (data) => {
  return request.post(`/app-api/therapy/survey/submitForTools`, {data});
};

/**
 * 大语言模型对话
 */
export const automatedThinking = (data) => {
  // https://github.com/mpetazzoni/sse.js
  return new SSE(baseURL + '/app-api/therapy/ai/automated-thinking', {
    method: 'POST',
    headers: {
      'accept': 'text/event-stream',
      'Content-Type': 'application/json',
      'tenant-id': 1,
      'Authorization': `Bearer ${getToken()}`
    },
    payload: JSON.stringify(data)
  });
};

export const getThinkingTaskSession = (dayItemInstanceId) => {
  return request.get('/app-api/therapy/ai/automated-thinking/session', {
    params: { dayItemInstanceId }
  });
};
